module.exports = __webpack_public_path__ + "static/img/close.83057758.png";